var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmDialogDestructiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_592_1072)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#DE332A",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_592_1072)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_592_1072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 62C52.1516 62 62 52.1516 62 40C62 27.8484 52.1516 18 40 18C27.8484 18 18 27.8484 18 40C18 52.1516 27.8484 62 40 62ZM40 29C41.143 29 42.0625 29.9195 42.0625 31.0625V40.6875C42.0625 41.8305 41.143 42.75 40 42.75C38.857 42.75 37.9375 41.8305 37.9375 40.6875V31.0625C37.9375 29.9195 38.857 29 40 29ZM42.75 48.25C42.75 49.7711 41.5211 51 40 51C38.4789 51 37.25 49.7711 37.25 48.25C37.25 46.7289 38.4789 45.5 40 45.5C41.5211 45.5 42.75 46.7289 42.75 48.25Z",
    fill: "#DE332A"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_592_1072"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_592_1072"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(18 18)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_592_1072"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(18 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmDialogDestructiveIcon);
export default __webpack_public_path__ + "static/media/confirm-dialog-destructive-icon.c0a064b48e3dcd802541f67b3c5eaa89.svg";
export { ForwardRef as ReactComponent };